"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ocm_object_1 = require("@ocm/services/ocm-object");
const department = (0, vue_1.ref)(ocm_object_1.department);
const departmentCapitalized = (0, vue_1.computed)(() => (department.value.charAt(0).toUpperCase() + department.value.slice(1)));
function useDepartment() {
    return {
        department,
        departmentCapitalized,
    };
}
exports.default = useDepartment;
